import { useShiftModalDataContext } from 'modals/ShiftModal/ShiftModalProvider.data.context';
import { useSSFBehaviors } from 'hooks';
import { SSFBehaviorsContextType } from 'hooks/useSSFBehaviors/useSSFBehaviors.types';
import { QUERY_sendToAgenciesSummaryViewTeamMembersCount } from 'queries';
import { FC, useContext, useMemo } from 'react';
import { SendToAgenciesSummaryViewTeamMembersCountQuery } from 'types/graphql';
import { createGQLDataContext } from 'utils/createDataContext';

export const FetchAvailableTeamMembersCountDataContext = createGQLDataContext<
  SSFBehaviorsContextType<SendToAgenciesSummaryViewTeamMembersCountQuery>
>({} as SSFBehaviorsContextType<SendToAgenciesSummaryViewTeamMembersCountQuery>);

export const FetchAvailableTeamMembersCountDataProvider: FC = ({ children }) => {
  const { data } = useShiftModalDataContext();
  const order = data!.order;

  const [values, rest] = useSSFBehaviors({
    key: 'SEND_TO_AGENCIES_SUMMARY_VIEW_FETCH_AVAILABLE_TEAM_MEMBERS_COUNT',
    query: QUERY_sendToAgenciesSummaryViewTeamMembersCount,
    payloadTransformer: (variables) => ({
      ...variables,
      filter: {},
    }),
    schema: {
      orderId: {
        initialValue: order.relayId,
      },
      positionId: {
        initialValue: order.position.displayId,
      },
      communityId: {
        initialValue: order.community.id,
      },
      breakTime: {
        initialValue: order.orderSchedule?.breakTime,
      },
    },
  });

  const contextValue = useMemo(() => ({ values, ...rest }), [rest, values]);

  return (
    <FetchAvailableTeamMembersCountDataContext.Provider value={contextValue}>
      {children}
    </FetchAvailableTeamMembersCountDataContext.Provider>
  );
};

export const useFetchAvailableTeamMembersCountDataContext =
  (): SSFBehaviorsContextType<SendToAgenciesSummaryViewTeamMembersCountQuery> =>
    useContext(FetchAvailableTeamMembersCountDataContext);
